module.exports = __webpack_public_path__ + "assets/img/mecha-active-btn-0a122f83.png";